import { GoodsDto, GoodsStatus, OrderGoodsItemDto, SiteDto } from '../../../api/ClientApi';
import { BareGoodsEntity } from '../../../redux/reducers/goodsToOrderFormReducer';

export const convertGoodsIdsToBareGoodsEntities = (
    goodsIds: number[],
    goods?: GoodsDto[],
    orderGoodsItems?: OrderGoodsItemDto[],
    site?: SiteDto,
) => {
    if (!goods) {
        return [];
    }

    return goods
        .filter((g) => !!g.id && goodsIds.includes(g.id))
        .map((g) => {
            let availableQuantity = Number.MAX_SAFE_INTEGER;
            // if there is site, add legit available quantity
            if (!!site) {
                if (!!site.goods) {
                    // all articles in stock on site quantity
                    availableQuantity = site.goods
                        .filter((sg) => sg.article?.id === g.article?.id && sg.goodsStatus === GoodsStatus.InStock)
                        .reduce((acc, value) => {
                            return (acc += value.quantity ?? 0);
                        }, 0);

                    // take away all ordered articles that are still on site
                    availableQuantity -=
                        orderGoodsItems
                            ?.filter((fgi) => fgi.articleId === g.article?.id)
                            .reduce((acc, val) => {
                                return (acc += val.quantity ?? 0);
                            }, 0) ?? 0;
                }
            }
            return {
                article: g.article,
                goods: [g],
                availableQuantity: availableQuantity,
                orderedQuantity: g.quantity,
                index: g.id,
            } as BareGoodsEntity;
        })
        .sort((a, b) => a.index - b.index);
};

export const convertOrderGoodsItemsToBareGoodsEntities = (
    orderGoodsItemsForOrder?: OrderGoodsItemDto[],
    site?: SiteDto,
    alreadyOrderedOrderGoodsItems?: OrderGoodsItemDto[],
) => {
    if (!orderGoodsItemsForOrder) {
        return [];
    }

    return orderGoodsItemsForOrder
        .map((ogi) => {
            let availableQuantity = Number.MAX_SAFE_INTEGER;
            let availableGoods: GoodsDto[] = [];
            // if there is site, add legit available quantity
            if (!!site) {
                if (!!site.goods) {
                    availableGoods = site.goods.filter(
                        (sg) => sg.article?.id === ogi.article?.id && sg.goodsStatus === GoodsStatus.InStock,
                    );
                    availableQuantity = availableGoods.reduce((acc, value) => {
                        return (acc += value.quantity ?? 0);
                    }, 0);
                    availableQuantity -=
                        alreadyOrderedOrderGoodsItems
                            ?.filter((fgi) => fgi.articleId === ogi.article?.id)
                            .reduce((acc, val) => {
                                return (acc += val.quantity ?? 0);
                            }, 0) ?? 0;
                }
            }
            return {
                article: ogi.article,
                goods: availableGoods ?? [],
                availableQuantity: availableQuantity,
                orderedQuantity: ogi.quantity,
                index: ogi.id,
            } as BareGoodsEntity;
        })
        .sort((a, b) => a.index - b.index);
};

export const convertGoodsToBareGoodsEntities = (goods?: GoodsDto[]) => {
    if (!goods) {
        return [];
    }

    const uniqueArticlesGoods = goods.filter(
        (value, index, array) => array.findIndex((g) => g.article?.id === value.article?.id) === index,
    );

    const returnGoods: BareGoodsEntity[] = [];

    uniqueArticlesGoods.map((uag) => {
        const currGoods = goods.filter((g) => !!g.article?.id && uag.article?.id === g.article.id);

        const availableQuantity = currGoods
            .filter((g) => g.goodsStatus === GoodsStatus.InStock)
            .reduce((acc, val) => {
                return (acc += val.quantity ?? 0);
            }, 0);

        const index = returnGoods.length === 0 ? 1 : returnGoods[returnGoods.length - 1].index + 1;

        returnGoods.push({
            article: uag.article,
            goods: currGoods,
            availableQuantity: availableQuantity,
            orderedQuantity: availableQuantity,
            index: index,
        } as BareGoodsEntity);
    });

    return returnGoods.sort((a, b) => a.index - b.index);
};
